<template>
  <div >
    <span class="font-weight-medium" :class="claseError">{{titulo}}</span>
    <span v-if="obligatorio" class="font-weight-bold ml-1" :class="claseError">*</span>
    <IconoInformacion :sInformacion="sInformacion"/>
    <v-radio-group  class="ma-0 pt-1" :class="claseError"
      v-model="valor" 
      row 
      dense
      :disabled="bEditable"
      :error="esError"
      :rules="noVacio">
        <v-radio label="Activo" value="1"></v-radio>
        <v-radio label="Inactivo" value="0"></v-radio>
    </v-radio-group>
  </div>
  </template>
  
  <script>
  import { mapGetters } from 'vuex'
  import FormMixin from '@/mixins/formularioMixin.js'
  import IconoInformacion from '@/components/Form/Componentes/subComponentes/IconoInformacion.vue'
  
  export default {
    name: 'FormActivoInactivo',
    mixins: [FormMixin],
    components: {
      IconoInformacion,
    },
    props: {
    },
    data() {
      return {
        valor   : this.value,
        esError : false,
        noVacio : [v => !!v],
        bEditable : (this.editable == "0") ? true : false,
      }
    },
    mounted(){
    },
    methods: {
  
    },
    computed: {
      ...mapGetters(['getoFormError'])
    },
    watch: {
    },
    
  }
  </script>
  
  <style scoped>
  
  
  </style>